import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-231da20e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-notify-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fire",
  style: {
    "margin-right": "0.04rem"
  }
}, "🔥", -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fire",
  style: {
    "margin-left": "0.04rem"
  }
}, "🔥", -1));
import { onMounted, getCurrentInstance, computed } from "vue";
import BigNumber from "bignumber.js";
import { numToString } from "@/utils";
// import AvatarComp from "@/components/Avatar";

export default {
  __name: 'index',
  setup(__props) {
    const {
      $store,
      $router
    } = getCurrentInstance().proxy;
    const notifyList = computed(() => $store.state.latestNotifyInfo?.notifyList);
    onMounted(() => {});
    function getAmount(item) {
      const amount = item.sol_amount - item.fee_sol_amount;
      return numToString(new BigNumber(amount).div(1e9).dp(9, BigNumber.ROUND_DOWN));
    }
    function goToTrade(item) {
      item?.mint ? $router.push({
        path: "/trade/" + item.mint
      }) : "";
    }

    // function getCoinNotify() {
    //     isPolling = false;
    //     if (pollingTimeoutId) {
    //         clearTimeout(pollingTimeoutId); // 清除定时器
    //         pollingTimeoutId = null;
    //     }
    //     $api.getCoinNotify({})
    //         .then(async (res) => {
    //             isPolling = true;
    //             if (!res.error_code) {
    //                 const data = res.data;
    //                 notifyList.value = data.latest_trades;
    //                 // 请求ipfs
    //                 if (data.latest_hill?.uri && hill_ipfs_info?.uri != data.latest_hill?.uri) {
    //                     try {
    //                         hill_ipfs_info = await fetchDataFromIPFS(data.latest_hill.uri);
    //                         hill_ipfs_info.uri = data.latest_hill.uri;
    //                     } catch (error) {
    //                         hill_ipfs_info = {};
    //                     }
    //                 }
    //                 $store.commit("updateLatestNotifyInfo", {
    //                     calculate_first: digitalInt(data.calculate_first, 0),
    //                     calculate_second: digitalInt(data.calculate_second, 0),
    //                     latest_hill: data.latest_hill,
    //                     hill_ipfs_info,
    //                 });
    //             }
    //         })
    //         .catch(() => {
    //             isPolling = true;
    //         })
    //         .finally(() => {
    //             if (isPolling) {
    //                 pollingTimeoutId = setTimeout(getCoinNotify, 5000); // 5秒后继续下一个请求
    //             }
    //         });
    // }

    return (_ctx, _cache) => {
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      const _component_van_notice_bar = _resolveComponent("van-notice-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_notice_bar, {
        scrollable: false,
        color: "#fff",
        background: "transparent"
      }, {
        default: _withCtx(() => [_hoisted_2, _createVNode(_component_van_swipe, {
          vertical: "",
          class: "notice-swipe",
          autoplay: 5000,
          loop: "",
          touchable: false,
          "show-indicators": false
        }, {
          default: _withCtx(() => [notifyList.value?.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(notifyList.value, (item, index) => {
            return _openBlock(), _createBlock(_component_van_swipe_item, {
              key: index
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.user_info?.user_name || "-") + " " + _toDisplayString(item?.is_buy ? "bought" : "sold") + " " + _toDisplayString(getAmount(item)) + " SOL of ", 1), _createElementVNode("span", {
                class: "trade_mint",
                onClick: $event => goToTrade(item)
              }, _toDisplayString(item?.coin_info?.name || "-"), 9, _hoisted_3)]),
              _: 2
            }, 1024);
          }), 128)) : (_openBlock(), _createBlock(_component_van_swipe_item, {
            key: 1
          }, {
            default: _withCtx(() => [_createTextVNode("Meme is a game! Bazinga!")]),
            _: 1
          }))]),
          _: 1
        }), _hoisted_4]),
        _: 1
      })]);
    };
  }
};